<template>
  <!-- Show Winner Template -->
  <section class="hero is-light is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column">
            <figure class="image">
              <img
                :src="winner.logo"
                class="animated flipInX"
                alt="Winner Logo"
                style="max-height: 300px;"
              />
            </figure>
            <div class="title has-text-centered animated fadeInDown">Winner</div>
          </div>
          <div class="column is-9">
            <article class="media" style="margin-bottom: 19px;">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img :src="winner.img" />
                </p>
              </figure>
              <div class="media-content">
                <p class="animated bounceInDown">
                  <a :href="winner.channelUrl" target="_new">
                    <strong style="font-size: x-large;">{{ winner.name }}</strong>
                  </a>
                </p>
                <small>( {{winner.totalComments+winner.totalReplies}} comments )</small>
              </div>
              <div class="media-right">
                <b-dropdown aria-role="list" position="is-bottom-left">
                  <button class="button is-danger is-small" slot="trigger" slot-scope="{ active }">
                    <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                  </button>
                  <b-dropdown-item @click="generateSVGImg()">
                    <b-icon icon="image"></b-icon>
                    <span style="vertical-align: super;">&nbsp; Download SVG</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="generateQRCode()">
                    <b-icon icon="qrcode"></b-icon>
                    <span style="vertical-align: super;">&nbsp; Generate QR Code</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </article>
            <!-- Comments -->
            <div class="content has-text-centered animated fadeIn">
              <table class="table is-bordered is-striped is-narrow">
                <tbody>
                  <tr v-for="item in winner.comments" :key="item.id">
                    <td>
                      <b-tooltip :label="item.crdt" position="is-right">&nbsp;{{ item.cmnt }}</b-tooltip>
                    </td>
                    <th style="width: 81px;">
                      <b-icon icon="thumb-up-outline"></b-icon>
                      <span style="vertical-align: inherit;">&nbsp;{{ item.tlks }}</span>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Sharing on Social Media -->
            <nav class="level animated swing">
              <div class="level-item">
                <!-- fb show: quote and url -->
                <social-sharing
                  :url="winner.videoUrl"
                  :title="share.title"
                  :quote="share.quote"
                  :description="share.description"
                  :hashtags="share.hashtags"
                  :twitter-user="share.twitterUser"
                  inline-template
                >
                  <div>
                    <network network="email">
                      <b-icon icon="email" id="sharicon" size="is-large" title="Share on Email"></b-icon>
                    </network>&nbsp;
                    <network network="facebook">
                      <b-icon
                        icon="facebook"
                        id="sharicon"
                        size="is-large"
                        title="Share on Facebook"
                      ></b-icon>
                    </network>&nbsp;
                    <network network="twitter">
                      <b-icon icon="twitter" id="sharicon" size="is-large" title="Share on Twitter"></b-icon>
                    </network>&nbsp;
                    <network network="telegram">
                      <b-icon
                        icon="telegram"
                        id="sharicon"
                        size="is-large"
                        title="Share on Telegram"
                      ></b-icon>
                    </network>&nbsp;
                    <network network="linkedin">
                      <b-icon
                        icon="linkedin"
                        id="sharicon"
                        size="is-large"
                        title="Share on Linkedin"
                      ></b-icon>
                    </network>&nbsp;
                    <network network="whatsapp">
                      <b-icon
                        icon="whatsapp"
                        id="sharicon"
                        size="is-large"
                        title="Share on Whatsapp"
                      ></b-icon>
                    </network>&nbsp;
                  </div>
                </social-sharing>
              </div>
            </nav>
            <p
              class="has-text-centered animated pulse"
              style="letter-spacing: 0.1em;"
            >Share the winner on a social media account.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Download winner svg image -->
    <div id="svg" class="is-hidden">
      <!-- <?xml version="1.0" encoding="UTF-8" standalone="no"?> -->
      <!-- <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> -->
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 851 315"
        width="851"
        height="315"
      >
        <defs>
          <path d="M8.28 10.84L842.72 10.84L842.72 277.51L8.28 277.51L8.28 10.84Z" id="adMtnT9VA" />
          <linearGradient
            id="gradientb4uK0J0TmH"
            gradientUnits="userSpaceOnUse"
            x1="425.5"
            y1="10.84"
            x2="-328.94"
            y2="409.36"
          >
            <stop style="stop-color: #f5f5f5;stop-opacity: 0.54" offset="0%" />
            <stop style="stop-color: #010000;stop-opacity: 1" offset="100%" />
          </linearGradient>
          <clipPath id="clipd1m8pee8TE">
            <use xlink:href="#adMtnT9VA" opacity="0.77" />
          </clipPath>
          <path d="M20.5 32.22L199.39 32.22L199.39 200L20.5 200L20.5 32.22Z" id="a2t70OVTbS" />
          <clipPath id="clipbqtdFqxle">
            <use xlink:href="#a2t70OVTbS" opacity="1" />
          </clipPath>
          <path
            d="M710.6 40.76C708.76 40.76 699.6 40.76 683.12 40.76C683.12 47.98 683.12 51.99 683.12 52.79C670.14 56.85 661.59 63.86 661.59 71.86C661.59 79.86 670.14 86.87 683.12 90.93C683.12 91.6 683.12 94.92 683.12 100.91C700.77 100.91 710.58 100.91 712.54 100.91C720.26 107.22 733.78 111.39 749.23 111.39C764.67 111.39 778.2 107.22 785.91 100.91C787.83 100.91 797.41 100.91 814.66 100.91C814.66 94.68 814.66 91.22 814.66 90.52C826.93 86.41 834.92 79.6 834.92 71.86C834.92 64.12 826.93 57.3 814.66 53.19C814.66 52.36 814.66 48.22 814.66 40.76C798.59 40.76 789.66 40.76 787.87 40.76C780.64 33.46 766.08 28.5 749.23 28.5C732.38 28.5 717.83 33.46 710.6 40.76Z"
            id="adQGQvZCe"
          />
          <text
            id="f18blmuiwF"
            x="513.06"
            y="215.22"
            font-size="33"
            font-family="Open Sans"
            font-weight="700"
            font-style="italic"
            letter-spacing="0"
            alignment-baseline="before-edge"
            transform="matrix(1 0 0 1 183.61486115357457 -160.8881610868506)"
            style="line-height:100%"
            xml:space="preserve"
            dominant-baseline="text-before-edge"
          >
            <tspan
              x="513.06"
              dy="0em"
              alignment-baseline="before-edge"
              dominant-baseline="text-before-edge"
              text-anchor="start"
            >Winner</tspan>
          </text>
          <text
            id="cspbUTaRj"
            x="511.04"
            y="140.56"
            font-size="24"
            font-family="'Trebuchet MS', Gadget, sans-serif"
            font-weight="600"
            font-style="normal"
            letter-spacing="0"
            alignment-baseline="before-edge"
            transform="matrix(1 0 0 1 -85.53906250000006 -88.22149442018386)"
            style="line-height:100%"
            xml:space="preserve"
            dominant-baseline="text-before-edge"
          >
            <a :xlink:href="svgData.winnerChannelUrl" target="_new">
              <tspan
                x="511.04"
                dy="0em"
                alignment-baseline="before-edge"
                dominant-baseline="text-before-edge"
                text-anchor="middle"
              >{{ svgData.winnerChannelName | truncate(30,'....') }}</tspan>
            </a>
          </text>
          <text
            id="b1C0kJmFRA"
            x="549.38"
            y="193.89"
            font-size="16"
            font-family="Open Sans"
            font-weight="600"
            font-style="normal"
            letter-spacing="0.16"
            alignment-baseline="before-edge"
            transform="matrix(1 0 0 1 -123.8774394019815 -99.7777777777778)"
            style="line-height:100%"
            xml:space="preserve"
            dominant-baseline="text-before-edge"
          >
            <tspan
              x="549.38"
              dy="0em"
              alignment-baseline="before-edge"
              dominant-baseline="text-before-edge"
              text-anchor="middle"
            >{{ svgData.winnerComment | truncate(60,'....') }}</tspan>
          </text>
          <text
            id="e4GtvrSBG1"
            x="235.28"
            y="47.45"
            font-size="15"
            font-family="Open Sans"
            font-weight="700"
            font-style="italic"
            letter-spacing="0.15"
            alignment-baseline="before-edge"
            transform="matrix(1 0 0 1 -210.0000000000002 174.2978833090728)"
            style="line-height:100%"
            xml:space="preserve"
            dominant-baseline="text-before-edge"
          >
            <a :xlink:href="svgData.videoUrl" target="_new">
              <tspan
                x="235.28"
                dy="0em"
                alignment-baseline="before-edge"
                dominant-baseline="text-before-edge"
                text-anchor="start"
              >{{ svgData.videoTitle | truncate(100,'....') }}</tspan>
            </a>
          </text>
          <path
            d="M708.74 141.19L813.98 141.19L813.98 241.74L708.74 241.74L708.74 141.19Z"
            id="dcHMDIt3d"
          />
          <clipPath id="clipa46Ukj1Wq">
            <use xlink:href="#dcHMDIt3d" opacity="1" />
          </clipPath>
        </defs>
        <g>
          <g>
            <g>
              <use xlink:href="#adMtnT9VA" opacity="0.77" fill="url(#gradientb4uK0J0TmH)" />
              <g clip-path="url(#clipd1m8pee8TE)">
                <use
                  xlink:href="#adMtnT9VA"
                  opacity="0.77"
                  fill-opacity="0"
                  stroke="#060606"
                  stroke-width="4"
                  stroke-opacity="1"
                />
              </g>
            </g>
            <g>
              <g clip-path="url(#clipbqtdFqxle)" opacity="1">
                <a :xlink:href="svgData.videoUrl" target="_new">
                  <image
                    :xlink:href="svgData.videoThumbnail"
                    x="0"
                    y="0"
                    width="300"
                    height="300"
                    transform="matrix(0.5962962962962961 0 0 0.5592592592592589 20.504175513092292 32.22222222222183)"
                  />
                </a>
              </g>
            </g>
            <g>
              <use xlink:href="#adQGQvZCe" opacity="1" fill="#3f3f3f" fill-opacity="1" />
              <g>
                <use
                  xlink:href="#adQGQvZCe"
                  opacity="1"
                  fill-opacity="0"
                  stroke="#000000"
                  stroke-width="1"
                  stroke-opacity="0"
                />
              </g>
            </g>
            <g id="hqLiNY3uH">
              <use xlink:href="#f18blmuiwF" opacity="1" fill="#ffffff" fill-opacity="1" />
            </g>
            <g id="gWiOX2O0P">
              <use xlink:href="#cspbUTaRj" opacity="1" fill="#080707" fill-opacity="1" />
            </g>
            <g id="b3kgfKsMh3">
              <use xlink:href="#b1C0kJmFRA" opacity="1" fill="#080707" fill-opacity="1" />
            </g>
            <g id="a39TUbJRIx">
              <use xlink:href="#e4GtvrSBG1" opacity="1" fill="#080707" fill-opacity="1" />
            </g>
            <g>
              <g clip-path="url(#clipa46Ukj1Wq)" opacity="1">
                <a :xlink:href="svgData.winnerChannelUrl" target="_new">
                  <image
                    :xlink:href="svgData.winnerChannelPhoto"
                    x="0"
                    y="0"
                    width="770.79"
                    height="763.33"
                    transform="matrix(0.1365309668028363 0 0 0.1317321688500722 708.7380754859482 141.18749999999997)"
                  />
                </a>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <!-- QR Code Model -->
    <b-modal :active.sync="qrData.showModel" :width="420" scroll="keep">
      <div class="card" style="padding: 10px;">
        <div class="card-image has-text-centered">
          <h1 class="title">Scan QR code</h1>
          <p>
            <qrcode :value="qrData.value" :options="{ size: 250 }"></qrcode>
          </p>
          <small>Right click to download QR Code.</small>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import Vue from "vue";

var SocialSharing = require("vue-social-sharing");
Vue.use(SocialSharing);

var download = require("downloadjs");

import VueQrcode from "@chenfengyuan/vue-qrcode";
Vue.component(VueQrcode.name, VueQrcode);

import winnerLogo from "@/assets/img/winner.svg";
import loader from "@/assets/img/loader.gif";

export default {
  name: "winner",
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      winner: {
        logo: winnerLogo,
        videoTitle: "",
        videoThumbnail: "",
        videoUrl: "",
        id: "",
        name: "",
        img: loader,
        channelUrl: "",
        totalComments: 0,
        totalReplies: 0,
        comments: []
      },
      share: {
        title: "",
        quote: "",
        description: "",
        hashtags: "",
        twitterUser: ""
      },
      // SVG File Data
      svgData: {
        svgFileName: "", // SVG File Name
        videoTitle: "",
        videoUrl: "",
        videoThumbnail: "",
        winnerChannelUrl: "",
        winnerChannelName: "",
        winnerChannelPhoto: "",
        winnerComment: ""
      },
      // QRCode Data
      qrData: {
        showModel: false,
        value: ""
      }
    };
  },
  filters: {
    truncate: function(text, stop, clamp) {
      return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
    }
  },
  methods: {
    socialSharing() {
      var data = {
        name: this.winner.name,
        channel: this.winner.channelUrl
      };

      var title =
        "" +
        "Congratulations! {name},\n" +
        "\n" +
        "You are elected the winner of this video.\n" +
        "Your YouTube Channel: {channel}\n" +
        "\n" +
        "Thanks for participating.\n" +
        "";

      title = title.replace(/{[^{}]+}/g, function(key) {
        return data[key.replace(/[{}]+/g, "")] || "";
      });

      this.share.title = title;
      this.share.quote = "";
      this.share.description = "";
      this.share.hashtags = "";
      this.share.twitterUser = "youtube";
    },

    /**
     * Generate Winner SVG Image
     */
    generateSVGImg: function() {
      var that = this;

      this.svgData.videoTitle = this.winner.videoTitle;
      this.svgData.videoUrl = this.winner.videoUrl;
      this.svgData.videoThumbnail = this.winner.videoThumbnail;
      this.svgData.winnerChannelUrl = this.winner.channelUrl;
      this.svgData.winnerChannelName = this.winner.name;
      this.svgData.winnerChannelPhoto = this.winner.img;
      this.svgData.winnerComment = this.winner.comments[0]["cmnt"];
      this.svgData.svgFileName = this.winner.videoTitle;

      // Event tracking in Google Analytics
      that.$ga.event(
        "Download SVG",
        that.winner.videoUrl,
        that.winner.channelUrl
      );

      setTimeout(function() {
        var svg_html = document.getElementById("svg").innerHTML;
        download(
          new Blob([svg_html]),
          that.svgData.svgFileName +
            "__Winner Name__ " +
            that.winner.name +
            ".svg",
          "text/svg"
        );
      }, 1000);
    },

    /**
     * Generate Winner QRCode
     */
    generateQRCode: function() {
      // Event tracking in Google Analytics
      this.$ga.event(
        "Generate QRCode",
        this.winner.videoUrl,
        this.winner.channelUrl
      );

      this.qrData.value =
        "Winner : " +
        this.winner.name +
        " \r\nChannel URL: " +
        this.winner.channelUrl +
        " \r\nGiveaway Video: " +
        this.winner.videoUrl +
        " \r\nVideo Title: " +
        this.winner.videoTitle.substring(0, 20) +
        "";

      // Show QRCode Model
      this.qrData.showModel = true;
    }
  },
  mounted() {
    if (
      this.value !== undefined &&
      this.value !== null &&
      typeof this.value === "object"
    ) {
      this.winner.id = this.value.userId;
      this.winner.channelUrl = this.value.channelUrl;
      this.winner.name = this.value.name;
      this.winner.img = this.value.photo;
      this.winner.totalComments = this.value.totalComment;
      this.winner.comments = this.value.comments;
      this.winner.videoTitle = this.value.videoTitle;
      this.winner.videoUrl = this.value.videoUrl;
      this.winner.videoThumbnail = this.value.videoThumbnail;

      // {@call}
      this.socialSharing();
    }
  }
};
</script>